/* CNC Cross-sell — Sprint 45 Phase 4
   Quick-add with error handling.
   Dispatches apps:product-added-to-cart for theme refresh. */

(function(){

  function addToCart(variantId, btn) {
    if (!variantId || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    btn.textContent = '...';

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');

    fetch(window.cncUrl('cart/add.js'), { method: 'POST', body: fd })
      .then(function(r) {
        if (!r.ok) {
          return r.json().then(function(data) {
            throw new Error(data.description || 'Could not add');
          });
        }
        return r.json();
      })
      .then(function() {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = 'ADDED';
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.textContent = 'ADD';
        }, 2000);
      })
      .catch(function(err) {
        btn.classList.remove('is-adding');
        btn.textContent = 'SOLD OUT';
        btn.disabled = true;
        btn.style.opacity = '0.4';
      });
  }

  document.addEventListener('click', function(e) {
    var cncBtn = e.target.closest('[data-cnc-quick-add]');
    if (cncBtn && !cncBtn.disabled) {
      e.preventDefault();
      addToCart(cncBtn.getAttribute('data-cnc-quick-add'), cncBtn);
    }
  });

  document.addEventListener('change', function(e) {
    var select = e.target.closest('[data-variant-selector]');
    if (!select) return;
    var card = select.closest('.cnc-cross-sell__card');
    if (!card) return;
    var btn = card.querySelector('[data-cnc-quick-add]');
    if (btn) {
      btn.setAttribute('data-cnc-quick-add', select.value);
      btn.disabled = false;
      btn.style.opacity = '';
      btn.textContent = 'ADD';
    }
  });

  document.addEventListener('change', function(e) {
    var select = e.target.closest('[data-cnc-variant-select]');
    if (!select) return;
    var item = select.closest('[data-cnc-upsell-item]');
    if (!item) return;
    var btn = item.querySelector('[data-cnc-quick-add]');
    if (!btn) return;
    btn.setAttribute('data-cnc-quick-add', select.value);
    btn.disabled = select.options[select.selectedIndex].disabled;
  });

  function initThemeQuickShop() {
    if (typeof window.__CNC_ProductItem !== 'function') return;
    var seriesSection = document.querySelector('.cnc-series-recs');
    if (seriesSection) window.__CNC_ProductItem(seriesSection);
  }

  if (document.readyState === 'complete') {
    initThemeQuickShop();
  } else {
    window.addEventListener('load', initThemeQuickShop);
  }

})();
